<template>
  <div id="sidebar-menu">
    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :style="[
        layoutobject.split(' ').includes('horizontal-wrapper')
          ? layout.settings.layout_type == 'rtl'
            ? { 'margin-right': margin + 'px' }
            : { 'margin-left': margin + 'px' }
          : { margin: '0px' },
      ]"
    >
      <li class="back-btn">
        <router-link to="/">
          <img
            class="img-fluid"
            src="../../assets/images/logo/amsde-new.png"
            alt=""
        /></router-link>
        <div class="mobile-back text-end">
          <span>Back</span>
          <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
        </div>
      </li>
      <!-- <li class="sidebar-main-title">
        <div>
          <h6 class="lan-1">Perfil: MiPyMEs</h6>
        </div>
      </li> -->
      
      <!-- Menú dinámico desde menu.json -->
      <template v-for="(menuItem, index) in menuItems" :key="index">
        <!-- Encabezado de sección -->
        <li v-if="menuItem.type === 'headtitle'" class="sidebar-main-title">
          <div>
            <h6>{{ menuItem.headTitle1 }}</h6>
          </div>
        </li>
        
        <!-- Separador horizontal -->
        <li v-else-if="menuItem.type === 'separator'" class="sidebar-separator">
          <hr />
        </li>

        <!-- Elemento de menú con enlace directo -->
        <li v-else-if="menuItem.type === 'link'" class="sidebar-list" :class="{ active: menuItem.active }">
          <label class="badge badge-light-primary"></label>
          <router-link
            class="sidebar-link sidebar-title"
            :class="{ active: menuItem.active }"
            :to="menuItem.path"
          >
            <vue-feather class="stroke-icon" :type="menuItem.icon" />
            <span>{{ menuItem.title }}</span>
          </router-link>
        </li>

        <!-- Elemento de menú con submenú -->
        <li v-else class="sidebar-list" :class="{ active: menuItem.active }">
          <label class="badge badge-light-primary"></label>
          <a
            class="sidebar-link sidebar-title"
            :class="{ active: menuItem.active }"
            href="javascript:void(0)"
            @click="setNavActive(menuItem)"
          >
            <vue-feather class="stroke-icon" :type="menuItem.icon" />
            <span>{{ menuItem.title }}</span>
          </a>
          
          <!-- Submenú si existe -->
          <ul v-if="menuItem.children && menuItem.children.length" class="sidebar-submenu" :class="{ 'menu-open': menuItem.active }">
            <li v-for="(child, childIndex) in menuItem.children" :key="childIndex" :class="{ active: $route.path === child.path }">
              <router-link v-if="child.path" :to="child.path" class="lan-4" :class="{ active: $route.path === child.path }">
                {{ child.title }}
              </router-link>
              <a v-else href="javascript:void(0)" @click="setNavActive(child)">
                {{ child.title }}
              </a>
            </li>
          </ul>
        </li>
      </template>
     
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { layoutClasses } from "../../constants/layout";

export default {
  name: "Navmenu",
  data() {
    return {
      layoutobj: {},
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
      sidebar: (state) => state.layout.sidebarType,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      width: (state) => state.menu.width,
      height: (state) => state.menu.height,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
    }),
    layoutobject: {
      get: function () {
        return JSON.parse(
          JSON.stringify(
            layoutClasses.find(
              (item) => Object.keys(item).pop() === this.layout.settings.layout
            )
          )
        )[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find(
          (item) => Object.keys(item).pop() === this.layout.settings.layout
        );
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
        return this.layoutobj;
      },
    },
  },
  watch: {
    $route(to) {
      this.updateActiveRoute(to.path);
    },
    width() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
      if (window.innerWidth < 992) {
        const newlayout = JSON.parse(
          JSON.stringify(this.layoutobject).replace(
            "horizontal-wrapper",
            "compact-wrapper"
          )
        );
        document.querySelector(".page-wrapper").className =
          "page-wrapper " + newlayout;
        this.$store.state.menu.margin = 0;
      } else {
        document.querySelector(".page-wrapper").className =
          "page-wrapper " + this.layoutobject;
      }

      if (
        (window.innerWidth < 1199 && this.layout.settings.layout === "Tokyo") ||
        (window.innerWidth < 1199 &&
          this.layout.settings.layout === "Moscow") ||
        (window.innerWidth < 1199 && this.layout.settings.layout === "Rome")
      ) {
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.$store.state.menu.width < 991) {
      this.layout.settings.layout = "Dubai";
      this.margin = 0;
    }
    setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      this.$store.state.menu.menuWidth = elmnt.offsetWidth;
      this.$store.state.menu.menuWidth > window.innerWidth
        ? ((this.$store.state.menu.hideRightArrow = false),
          (this.$store.state.menu.hideLeftArrowRTL = false))
        : ((this.$store.state.menu.hideRightArrow = false),
          (this.$store.state.menu.hideLeftArrowRTL = true));
    }, 0);
    this.layoutobject = layoutClasses.find(
      (item) => Object.keys(item).pop() === this.layout.settings.layout
    );
    this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[
      this.layout.settings.layout
    ];
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.menuItems.filter((items) => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter((subItems) => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 400) {
        if (
          this.layoutobject.split(" ").pop() === "material-type" ||
          this.layoutobject.split(" ").pop() === "advance-layout"
        )
          document.querySelector(".sidebar-main").className =
            "sidebar-main hovered";
      } else {
        if (document.getElementById("sidebar-main"))
          document.querySelector(".sidebar-main").className = "sidebar-main";
      }
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
      if (
        this.layoutobject.split(" ").includes("compact-sidebar") &&
        window.innerWidth > 991
      ) {
        if (this.menuItems.some((menuItem) => menuItem.active === true)) {
          this.$store.state.menu.activeoverlay = true;
        } else {
          this.$store.state.menu.activeoverlay = false;
        }
      }
    },
    hidesecondmenu() {
      if (window.innerWidth < 991) {
        (this.$store.state.menu.activeoverlay = false),
          (this.$store.state.menu.togglesidebar = false);
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      } else if (this.layoutobject.split(" ").includes("compact-sidebar")) {
        (this.$store.state.menu.activeoverlay = false),
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
      }
    },
    handleResize() {
      this.$store.state.menu.width = window.innerWidth - 450;
    },
    updateActiveRoute(path) {
      this.menuItems.forEach((menuItem) => {
        if (menuItem.path === path) {
          this.$store.dispatch("menu/setActiveRoute", menuItem);
        }
        if (menuItem.children) {
          menuItem.children.forEach((child) => {
            if (child.path === path) {
              this.$store.dispatch("menu/setActiveRoute", child);
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.sidebar-feather-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  vertical-align: middle;
}

.sidebar-separator {
  list-style: none;
  padding: 0 16px;
  margin: 4px 0;
}

.sidebar-separator hr {
  border: none;
  border-top: 1px solid #9c9fa2dd;
  margin: 0;
}
</style>